export const namespaced = true;

export const state = {
    engravings: [],
    fonts: [],
    loadingElements: false,
}

export const mutations = {
    FETCH_ENGRAVINGS(state, engravings) {
        state.engravings = engravings;
    },

    FETCH_FONTS(state, fonts) {
        state.fonts = fonts;
    },

    SET_TYPE_ELEMENTS(state, { elementGroupId, typeId, elements }) {
        const groupIndex = state.engravings.findIndex(e => e.element_group_id == elementGroupId);
        if (groupIndex >= 0) {
            const typeIndex = state.engravings[groupIndex].types.findIndex(t => t.type_id == typeId);
            if (typeIndex >= 0) {
                if (state.engravings[groupIndex].types[typeIndex].elements.length) {
                    elements.forEach(element => {
                        state.engravings[groupIndex].types[typeIndex].elements.push(element);
                    });
                } else {
                    state.engravings[groupIndex].types[typeIndex].elements = elements;
                }
                state.engravings = [...state.engravings];
            }
        }

    },

    SET_TYPE_META(state, { elementGroupId, typeId, meta }) {
        const groupIndex = state.engravings.findIndex(e => e.element_group_id == elementGroupId);
        if (groupIndex >= 0) {
            const typeIndex = state.engravings[groupIndex].types.findIndex(t => t.type_id == typeId);
            if (typeIndex >= 0) {
                state.engravings[groupIndex].types[typeIndex].meta = meta;
                state.engravings = [...state.engravings];
            }
        }
    },

    SET_LOADING_ELEMENTS(state, { loading }) {
        state.loadingElements = loading;
    }
}

export const actions = {

    async fetch({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/engravings`)).data;
            commit('FETCH_ENGRAVINGS', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                element: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async getFonts({ commit, state, dispatch }, fonts_id = '[]') {
        try {
            const res = (await axios.get(`/api/fonts`, {
                params: {
                    fonts_id: JSON.parse(fonts_id)
                }
            })).data;
            commit('FETCH_FONTS', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                element: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async getElementsByType({ commit, dispatch, state, rootState }, { elementGroupId, typeId }) {
        commit('SET_LOADING_ELEMENTS', true);
        let page = 1;

        const group = state.engravings.find(e => e.element_group_id == elementGroupId);
        if (group) {
            const type = group.types.find(t => t.type_id == typeId);

            if (type && type.meta && type.meta.current_page) {
                page = type.meta.current_page + 1;
            }
        }

        try {
            const res = (await axios.get(`/api/type-engravings/${typeId}`, {
                params: {
                    per_page: parseInt(rootState.settings.settings.count_elements_engravings) || 36,
                    page
                }
            })).data;
            // commit('SET_TYPE_ELEMENTS', { elementGroupId, typeId, elements: res.data });
            commit('SET_TYPE_META', { elementGroupId, typeId, meta: res?.meta });
            return res.data;
        } catch (error) {
            const notification = {
                element: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        } finally {
            commit('SET_LOADING_ELEMENTS', false);
        }
    },

    clearElementsByType({ commit }, { elementGroupId, typeId }) {
        commit('SET_TYPE_ELEMENTS', { elementGroupId, typeId, elements: [] });
        commit('SET_TYPE_META', { elementGroupId, typeId, meta: null });
    }

}
